import type {ReactNode} from 'react'

import {usePullRequestState} from '../../../../hooks/use-pull-request-state'
import {PullRequestState} from '../../../../types'
import {useMergeabilityData, type MergeabilityData} from '../mergeability/use-mergeability-data'
import {ClosedPR, shouldShowClosedPR} from '../pull-request-state/ClosedPR'
import {MergedPR, shouldShowMergedPR} from '../pull-request-state/MergedPR'
import {QueuedPR, shouldShowQueuedPR} from '../pull-request-state/QueuedPR'

export function useLifecycleDecider() {
  return getLifecycleAction({
    pullRequestState: usePullRequestState(),
    mergeabilityData: useMergeabilityData(),
  })
}

export function getLifecycleAction({
  pullRequestState,
  mergeabilityData,
}: {
  pullRequestState: PullRequestState
  mergeabilityData: MergeabilityData | null
}): ReactNode {
  if (shouldShowClosedPR(pullRequestState)) return <ClosedPR />

  if (shouldShowMergedPR(pullRequestState)) return <MergedPR />

  if (shouldShowQueuedPR(mergeabilityData)) return <QueuedPR />

  return null
}
